/*
 * Module for the Rollover Account Type step of the DROP Distribution Election form
*/
rs.module("ui/content/communications/onlineforms/rolloveraccounttype",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var rolloverAccountTypeRadio = stepContainer.js(jsSelectors.rolloverAccountTypeRadio, { multiple: true });
            var rolloverAccountTypeDescriptionDiv = stepContainer.js(jsSelectors.rolloverAccountTypeDescriptionDiv, { multiple: true });

            var selected = rolloverAccountTypeRadio.filter(":checked");
            var selectedIndex = rolloverAccountTypeRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedRolloverAccountTypeDescription(selectedIndex);
            }

            // Handle the rolloverAccountTypeRadio click event
            rolloverAccountTypeRadio.on("click", function () {

                var selectedIndex = rolloverAccountTypeRadio.index(this);
                showSelectedRolloverAccountTypeDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected rollover account type
            function showSelectedRolloverAccountTypeDescription(selectedIndex) {

                // Close all quickly
                rolloverAccountTypeDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                rolloverAccountTypeDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);